import PropTypes from 'prop-types';
export const selectPropTypes = {
  /**
   * Field name value as string
   */
  name: PropTypes.string.isRequired,
  /**
   * Placeholder value
   */
  placeholder: PropTypes.string,
  /**
   * Additional classname
   */
  classname: PropTypes.string,
  /**
   * Options as array
   */
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })).isRequired
};